<div class="product-thumbnail" id="product-thumbnail">
    <div class="product-thumbnail__description" id="product-thumbnail-description">
        <caption class="product-thumbnail__caption" id="product-thumbnail-item" *ngIf="type === 'img'">{{indexSelected + 1}} de {{listThumbnail.length}} {{type === 'img' ? 'fotos' : 'videos'}}</caption>
        <label class="product-thumbnail__label" id="product-thumbnail-image_name" for="product-carousel-item-current">{{nameImg()}}</label>
    </div>
  <div class="product-thumbnail__content">
    <ul class="product-thumbnail__list" id="product-thumbnail-list">
        <li class="product-thumbnail__item" *ngFor="let item of listThumbnail; let i = index" (click)=clickThumbnail(i)>
            <img default *ngIf="item?.linkThumbnail" [class.product-thumbnail__opacity-image]="i !== indexSelected" [class.product-thumbnail__active]="i === indexSelected"  [src]="item.linkThumbnail" [alt]="item.linkThumbnail">
        </li>
      </ul>
  </div>
</div>
